import Colors from 'appearance/colors'
import Fonts from 'appearance/fonts'
import {styled} from 'common'

const StatisticsCardTitle = styled.span`
    font-family: Actor;
    font-weight: 400;
`

const ForgotPasswordText = styled.span`
    font-family: Actor;
    font-weight: 600;
`

const RegularText = styled.span`
    font-family: Gilroy-semiBold;
`

const MediumText = styled.span`
    font-family: Gilroy-semiBold;
    font-weight: 500;
`

const BoldText = styled.p`
    font-family: Montserrat;
    font-weight: 700;
`

const TableText = styled.span`
    font-family: Inter;
`

const BoldTableText = styled.span`
    font-family: Inter;
    font-weight: bold;
    color: ${Colors.DARK_CHARCOAL};
`

const MainText = styled.span`
    font-family: ${Fonts.APP_MAIN};
`

const Title = styled.span`
    font-family: ${Fonts.APP_MAIN};
    font-size: 24px;
`

const FadedGreyText = styled.span`
    color: ${Colors.APP_FADED_GREY};
    font-family: ${Fonts.APP_MAIN};
    font-size: 14px;
`

const ShippingTableText = styled.span`
    font-family: ${Fonts.TABLE_TEXT};
    font-size: 12px;
    color: #828282;
    font-weight: 400;
`

const Texts = {
    RegularText,
    MediumText,
    BoldText,
    TableText,
    BoldTableText,
    MainText,
    Title,
    FadedGreyText,
    ShippingTableText,
    StatisticsCardTitle,
    ForgotPasswordText,
}
export default Texts
